var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.482 26.7135L34.5 28.5H27.75C27.5511 28.5 27.3603 28.421 27.2197 28.2803C27.079 28.1397 27 27.9489 27 27.75V22.971C27 16.083 30.3495 10.5 34.482 10.5L34.5 10.5165L34.485 10.5V28.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 28.5H34.5V35.25C34.5 35.8467 34.2629 36.419 33.841 36.841C33.419 37.2629 32.8467 37.5 32.25 37.5C31.6533 37.5 31.081 37.2629 30.659 36.841C30.2371 36.419 30 35.8467 30 35.25V28.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 21.5996V25.4996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 27.75C19.5 26.5074 18.4926 25.5 17.25 25.5C16.0074 25.5 15 26.5074 15 27.75V35.25C15 36.4926 16.0074 37.5 17.25 37.5C18.4926 37.5 19.5 36.4926 19.5 35.25V27.75Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17.25V10.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5V18.6C21 19.3956 20.6839 20.1587 20.1213 20.7213C19.5587 21.2839 18.7956 21.6 18 21.6H16.5C15.7044 21.6 14.9413 21.2839 14.3787 20.7213C13.8161 20.1587 13.5 19.3956 13.5 18.6V10.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.25H13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenPoi);
export default __webpack_public_path__ + "static/media/kitchen-poi.c21db578efedeb630c3186e362e1b1da.svg";
export { ForwardRef as ReactComponent };